import { render, staticRenderFns } from "./PostDetailsModal.vue?vue&type=template&id=0291cc64&"
import script from "./PostDetailsModal.vue?vue&type=script&lang=js&"
export * from "./PostDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports